var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLocation } from "react-router-dom";
import { getData } from "country-list";
import { toast, } from "@here/hds-notification";
import { ALLOWED_FILE_EXTENSION, ALLOWED_FILE_TYPES, INDOOR_MAP, REGEX_PATTERNS, UNEmbargoAlpha2Codes, } from "../../store/common/constants";
export default {
    debounce: function (callback, time) {
        var timeout;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                callback.apply(void 0, args);
            }, time);
        };
    },
    useQuery: function () {
        return new URLSearchParams(useLocation().search);
    },
    isNotPrd: function (domain) { return domain !== "platform.here.com"; },
    formattedDate: function (locale, date) {
        return new Intl.DateTimeFormat(locale, {
            day: "numeric",
            year: "numeric",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        }).format(date);
    },
    formatDateWithYearMonthDayFormat: function (date) {
        var d = new Date(date);
        var month = "" + (d.getMonth() + 1);
        var day = "" + d.getDate();
        var year = d.getFullYear();
        if (month.length < 2) {
            month = "0" + month;
        }
        if (day.length < 2) {
            day = "0" + day;
        }
        return [year, month, day].join("-");
    },
    formatDraftHrn: function (envName, realm, id) {
        return "hrn:" + envName + ":data::" + realm + ":" + id + "-draft";
    },
    convertArrayToObject: function (array, key) {
        var initialValue = {};
        return array.reduce(function (obj, item) {
            var _a;
            return __assign(__assign({}, obj), (_a = {}, _a[item[key]] = item, _a));
        }, initialValue);
    },
    getPropertyValueByString: function (path, obj, separator) {
        if (obj === void 0) { obj = self; }
        if (separator === void 0) { separator = "."; }
        var properties = Array.isArray(path) ? path : path.split(separator);
        return properties.reduce(function (prev, curr) { return prev && prev[curr]; }, obj);
    },
    mergeByProperty: function (arr1, arr2) {
        return arr1.map(function (item) {
            var fn = arr2 && arr2.length > 0 && arr2.find(function (a) { return a.id == item.id; });
            if (fn) {
                return fn;
            }
            return item;
        });
    },
    camelize: function (str) {
        return str === null || str === void 0 ? void 0 : str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0) {
                return "";
            }
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    },
    getTimeByDate: function (snapshotDate) {
        return new Date(snapshotDate).getTime();
    },
    verifyLatitudeValue: function (input) {
        return REGEX_PATTERNS.LATITUDE.test(input);
    },
    verifyLongitudeValue: function (input) {
        return REGEX_PATTERNS.LONGITUDE.test(input);
    },
    isRealmAllowed: function (realm) {
        return INDOOR_MAP.ALLOWED_REALMS.includes(realm);
    },
    notify: function (title, body, duration, status, variant, iconStyle) {
        var toastOptions = {
            title: title,
            body: body,
            timeout: duration,
            status: status,
            iconStyle: iconStyle,
            variant: variant || "subtle",
        };
        toast(toastOptions);
    },
    getCountryList: function () {
        var countries = getData().filter(function (country) { return !UNEmbargoAlpha2Codes.includes(country.code); });
        var getFilteredCountries = countries.map(function (country) {
            return { value: country.name.toLowerCase(), label: country.name };
        });
        return getFilteredCountries;
    },
    getFormDropdownStyle: function (hdsStyles, error) {
        var customStyle = hdsStyles;
        customStyle.control = hdsStyles.control = function (provided, state) {
            return __assign(__assign({}, provided), { background: "var(--hds-background--primary)", border: !error
                    ? state.isFocused
                        ? "var(--hds-border-width) solid var(--hds-object-focused)"
                        : "var(--hds-border-width) solid var(--hds-foreground-tertiary)"
                    : "var(--hds-border-width) solid var(--hds-negative)", borderRadius: "var(--hds-border-radius)", boxShadow: "none", paddingRight: "var(--hds-spacing-2)" });
        };
        return customStyle;
    },
    getMapUUId: function (hrn) {
        return hrn && hrn.split(":").pop();
    },
    getMapId: function (mapUUId) {
        return mapUUId.substr(mapUUId.length - 5);
    },
    getRealmFromHrn: function (hrn) {
        return hrn && hrn.split(":")[4];
    },
    isFileValid: function (file) {
        var fileType = file.type;
        var extractExtension = file.name.split(".").pop();
        var fileExt = (extractExtension || "").toLowerCase();
        if (file.type) {
            if (ALLOWED_FILE_TYPES.includes(fileType)) {
                return true;
            }
        }
        else {
            if (ALLOWED_FILE_EXTENSION.includes(fileExt)) {
                return true;
            }
        }
        return false;
    },
    isEmpty: function (args) {
        if (Array.isArray(args)) {
            if (args.length > 0) {
                return false;
            }
            return true;
        }
        else {
            for (var prop in args) {
                if (args.hasOwnProperty(prop)) {
                    return false;
                }
            }
            return true;
        }
    },
    /**
     * This will validate "venueId" passed is in micello or UUID format
     * it should strictly check for pattern eg "indoormap-00000000-0000-4000-a000-000000028476", assuming that as micello id
     * @returns boolean
     */
    validateIsMicelloId: function (id) {
        var regex = /^indoormap-00000000-0000-4000-[a-f]000-[0-9]{12}$/;
        var pattern = new RegExp(regex);
        return pattern.test(id);
    },
};
